import { ref, readonly, onMounted, onUnmounted } from 'vue'
import type { ScoreEntry } from '../lib/types'

export function useHistory() {
  const entries = ref<ScoreEntry[]>([])

  function load() {
    try {
      entries.value = JSON.parse(localStorage.getItem('af_pt_history') || '[]')
    } catch {
      entries.value = []
    }
  }

  function deleteEntry(id: number) {
    // Delegate to vanilla: updates scoreHistory global, localStorage, Firestore,
    // then dispatches ptr:history-changed which triggers our load().
    window.deleteHistory?.(id)
  }

  load()

  onMounted(() => {
    window.addEventListener('ptr:history-changed', load)
  })
  onUnmounted(() => {
    window.removeEventListener('ptr:history-changed', load)
  })

  return { entries: readonly(entries), deleteEntry }
}
